module.exports = __webpack_public_path__ + "img/restobar.893d3c03.png";